// Capitaliser une string
export const capitalize = (s: string) => s.length
  ? s.charAt(0).toUpperCase() + s.slice(1)
  : s;

// Convertit une chaine en slug utilisable dans les URLs
export const sanitizeSlug = (value: string) => value
  .toLowerCase()
  .normalize('NFD')
  .replace(/[^a-z0-9-_\s]/g, '')
  .trim()
  .replace(/\s+/g, '-')
  .replace(/-+/g, '-')
  .replace(/^-|-$/g, '');

export const getDateStatus = (date:Date) => {
  const now:any = new Date();
  const target:any = new Date(date);
  const diff = target - now; // en ms
  const oneMonth = 1000 * 60 * 60 * 24 * 30;

  return diff > 0
    ? "soon"
    : Math.abs(diff) <= oneMonth
      ? "new"
      : "old";
}

export const formatTimer = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };